import React, { Component } from 'react';
import compose from 'recompose/compose';
import { connect } from 'react-redux';
import { withStyles } from '@material-ui/core/styles';
import {
	changeCurrentPath,
	fetchMainList,
	resetMainListState,
	updateDate,
} from '../../actions';

import Header from '../../common/containers/header';
import Progress from '../../common/containers/progress'
import Footer from '../../common/containers/footer';

import ErrorDialog from '../../common/components/dialog/error-dialog';
import AlertDialog from '../../common/components/dialog/alert-dialog';
import ReloadModal from '../../common/components/dialog/reload-dialog';

import Tables from '../../common/components/table/common-table';

import {isIE} from '../../common/utils/brower';

const columns = [
	{ name: 'SDSName', title: '製品名',width:300 },
	{ name: 'DownLoad', title: ' ' ,width:120,sortingEnabled:false,filteringEnabled: false},
	{ name: 'RevisionNODisp', title: '改訂版数.' ,width:180},
	{ name: 'RevisionDate', title: '改訂日' ,width:180},
];

const styles = theme => ({
});

class MainList extends Component {

	constructor(props) {
		super(props);
		this.state = {
			isOpenError:false,
			contactOpen:false,
		}
	}

	/** override methods **/
    componentWillMount(){
    	this.handleClickSumup();
	}
	componentDidMount() {
		const { dispatch, history } = this.props;
		window.scrollTo(0, 0);
		dispatch(changeCurrentPath({ currentPath: history.location.pathname }));

	}
	componentWillUnmount(){
		const { dispatch} = this.props;
		dispatch(resetMainListState());
	}
    
    
    /** event handlers **/
	handleClickSumup = event => {
		const {dispatch, auth} = this.props;
		dispatch(fetchMainList({
			UserID : auth.user.UserID
		}));
	};

	handleClickDL = row => {
		if(!row.fileExists){
			this.setState({
				isOpenError:true
			});
			return;
		}

		const {dispatch, auth} = this.props;
		dispatch(updateDate({
			UserID : auth.user.UserID,
			SDSCD : row.SDSCD,
			RevisionNO : row.RevisionNO,
		}));
		this.doDownload(row.pdfPath,row.DocumentName);
	};

	doDownload = (pathname,filename) =>{

		filename = filename || 'file';

		if(isIE()){
			let xhr = new XMLHttpRequest();
			xhr.open("GET", pathname);
			xhr.responseType = "blob";
			xhr.send();
			xhr.onload = function(){
				navigator.msSaveOrOpenBlob(xhr.response, filename)
			}
		}
		else{
			let link = document.createElement('a');
			link.download = filename;
			link.href = pathname;
			link.click();
		}

	};

	okFunction = () =>{
		this.setState({
			isOpenError:false
		})
	};

	openContactForm(){
		this.setState({
			contactOpen:true
		})
	}

	closeContactForm(){
		this.setState({
			contactOpen:false
		})
	}




	render() {
		const { settings } = this.props;
		columns[0]["width"] = (this.props.navigation.windowWidth) - 58 - 480;

		const rows = settings.data;
		const clickableColumns = [
			{name:'DownLoad',func:this.handleClickDL,type:'button',text:'ダウンロード'}
		];

		return (
			<div id="main_container">
				{settings.isFetching &&
				<Progress/>
				}
				<Header history={this.props.history}/>
				<article>
					<section>
						<Tables
							dataSource={rows}
							columns={columns}
							clickableColumns={clickableColumns}
							hasSelections={false}
                            isShowTotalCount={false}
							defaultSortColumn={"SDSName"}
						/>
					</section>
				</article>
				<Footer/>
				<ErrorDialog
					open={this.props.settings.isProcessError}
				/>
				<AlertDialog
					open={this.state.isOpenError}
					title={"ダウンロードエラー"}
					text={"PDFファイルがみつかりません"}
					isOnlyOK={true}
					okFunction={this.okFunction}
				/>
				<ReloadModal />
			</div>
		);
	}
}

function mapStateToProps(state) {
	return {
		navigation : state.navigation,
		auth: state.auth,
		settings : state.mainListSettings
	};
}
export default compose(
	withStyles(styles),
	connect(mapStateToProps)
)(MainList);



// WEBPACK FOOTER //
// ./src/routes/main-list/index.js